var _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCritLowHumidity = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  "data-name": "Component 4 \\u2013 1"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#f90",
  stroke: "#2f2f2f",
  strokeWidth: 5,
  "data-name": "Rectangle 9"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M2.5 2.5h35v35h-35z"
}))), _text || (_text = /*#__PURE__*/React.createElement("text", {
  fill: "#282828",
  fontFamily: "SegoeUI-Semibold, Segoe UI",
  fontSize: 26,
  fontWeight: 600,
  transform: "translate(11 28)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "D"))));
export default SvgCritLowHumidity;